<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.asset_repository_create"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="assetService.loading()"
    [iconButton]="true"
    (click)="assetService.addRepository()"
    sbTooltip="{{ 'lang.globals.repository.create' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="assetService.requestDebouncedRepositories()"
    [disabled]="assetService.loading()"
    [loading]="assetService.loading()">
  </button>

</ng-container>

<!------------------------------

  side panel / Edit/Create

-------------------------------->

<sb-comp-side-panel (showChange)="assetService.showSideBar = $event" [show]="assetService.showSideBar" [sidebarHeader]="sidebarHeader"
                    [sidebarTemplate]="compSidePanelTemplate" [width]="550">

</sb-comp-side-panel>

<ng-template #sidebarHeader>
  <div class="d-flex">
    <h4 *ngIf="assetService.selectedRepository" [innerHTML]="assetService.selectedRepository?.name | truncate : 30"></h4>
    <h4 *ngIf="!assetService.selectedRepository">{{ 'lang.globals.newFile' | translate }}</h4>
  </div>
</ng-template>

<ng-template #compSidePanelTemplate>
  <sb-page-repositories-edit></sb-page-repositories-edit>
</ng-template>


<!------------------------------

    Table wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.globals.repositories'|translate : {name: assetService?.selectedRepository?.name} }}"
  [itemsData]="assetService.repositories"
  (paginationChange)="assetService.requestDebouncedRepositories($event)"
  [loading]="assetService.loading()"
  [itemName]="'repositories'">

  <!------------------------------

      Filter Panel

------------------------------->
  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="assetService.filterConfig"
    >

    </sb-filter-panel>
  </div>


  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>

    <tr>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.created' | translate }}
      </th>
      <th>
        {{ 'lang.globals.sharedWith' | translate }}
      </th>
      <th>
        {{ 'lang.globals.sharedFrom' | translate }}
      </th>
      <th>
        {{ 'lang.globals.sharedTill' | translate }}
      </th>
      <th>
        {{ 'lang.globals.assetCount' | translate }}
      </th>
      <th class="sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-repo>

    <tr>
      <td>
        {{ repo?.id }}
      </td>
      <td>
        <sb-comp-name-wrapper>
          <span firstLine
                class="cursor-pointer" [pathParams]="[{id: 'repositoryID', value: repo?.id}]"
                [sbRouterLink]="util.RoutingID.assets"
                ngbTooltip="{{'lang.globals.assets' | translate}}" container="body"
                [innerHtml]="repo?.name|truncate:30"></span>
          <span secondLine>{{ repo?.assets?.length }}</span>
        </sb-comp-name-wrapper>
      </td>
      <td>
        <sb-comp-display-created [data]="repo"></sb-comp-display-created>
      </td>
      <td>
        &nbsp;{{ repo?.clientCull?.name }}
      </td>
      <td>
        {{ repo?.shareStart?.toString() | date: 'dd.MM.yy HH:mm:ss' }}
      </td>
      <td>
        {{ repo?.shareEnd?.toString() | date: 'dd.MM.yy HH:mm:ss' }}
      </td>
      <td>
        {{ repo?.assetCount }}
      </td>
      <td class="tr sticky-col last-col tableBg">
        @if (!isInModalContext) {
          <sb-split-button
            [splitButtonItems]="repo.sbButtons ?? []"
            (selectedAction)="assetService.resolveSplitButtonActionRepositories(repo, $event)"
          ></sb-split-button>
        } @else {
          <button sb-button-secondary
                  type="button"
                  ngbTooltip="{{'lang.globals.select' | translate}}"
                  (click)="selectRepository(repo)"
                  [icon]="'boxChecked'"
                  [color]="'blue'"
                  [iconButton]="true">
          </button>
        }
      </td>
    </tr>
  </ng-template>

  <!------------------------------

   Card Element

------------------------------->
  <!--
    <ng-template #card let-repository>
      <sb-card>
        <div card-img classes="position-relative">

          <sb-preview-tooltip [interval]="5000" [hoverPreview]="false" [showFullOnClick]="true"
                              [customWidth]="100+'%'" [customHeight]="300+'px'"
                              [previews]="campaign?.preview"></sb-preview-tooltip>

          <div style="position: absolute;top: 15px;right: 15px">
            <button class="btn btn-danger" (click)="assetService.deleteRepository(repository)">
              <sb-icon icon="trash"></sb-icon>
            </button>
          </div>
        </div>
        <div card-footer>
          <div class="d-flex justify-content-between align-items-center">
            <div *ngIf="repository?.sharedBy">
              <sb-icon icon="diveDeeper" class="mr-1"></sb-icon>
              <sb-comp-image-name-wrapper [background]="true" [image]="repository.sharedBy.primaryCompany.logo">
                <span firstLine>
                  {{repository?.sharedBy?.name}}
                </span>
              </sb-comp-image-name-wrapper>
            </div>
            <div *ngIf="repository?.clientCull">
              <sb-comp-name-wrapper>
                <sb-comp-link
                  firstLine
                  [title]="repository?.clientCull?.name"
                  [condition]="permissionService.hasPermission(permissionService.Permission.cull_show)"
                  [link]="util.RoutingID.filterDetails" [pathParams]="[{id: 'filterID', value: repository?.clientCull?.id}]">
                </sb-comp-link>
              </sb-comp-name-wrapper>
            </div>
            <div class="d-flex">
              <sb-icon class="mr-1" icon="category"></sb-icon>
              {{repository?.category ? repository?.category?.name : '-'}}
            </div>
            <div class="d-flex ">
              <sb-icon class="mr-1" icon="photos"></sb-icon>
              {{repository?.assets ? repository?.assets?.length : '-'}}
            </div>
          </div>
        </div>
      </sb-card>
      <h3>
        {{repository.name}}
      </h3>
    </ng-template>
    -->

</sb-table-wrapper-new>
